var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotePadMint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66406 5.33203H5.77517C5.48049 5.33203 5.19787 5.44909 4.9895 5.65747C4.78113 5.86584 4.66406 6.14846 4.66406 6.44314V14.2209C4.66406 14.5156 4.78113 14.7982 4.9895 15.0066C5.19787 15.215 5.48049 15.332 5.77517 15.332H13.553C13.8476 15.332 14.1303 15.215 14.3386 15.0066C14.547 14.7982 14.6641 14.5156 14.6641 14.2209V10.332",
    stroke: "#508A9C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2844 5.01996C13.5098 4.79458 13.8154 4.66797 14.1342 4.66797C14.4529 4.66797 14.7586 4.79458 14.9839 5.01996C15.2093 5.24533 15.3359 5.55101 15.3359 5.86974C15.3359 6.18847 15.2093 6.49414 14.9839 6.71952L9.60201 12.1014L7.33594 12.668L7.90246 10.4019L13.2844 5.01996Z",
    stroke: "#508A9C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotePadMint);
export default __webpack_public_path__ + "static/media/Icon_NotePad_Mint.c9f66c60b9771e262c62dcdd7fb2dca6.svg";
export { ForwardRef as ReactComponent };